import { render, staticRenderFns } from "./landingDenied.vue?vue&type=template&id=26cbafa4&"
import script from "./landingDenied.vue?vue&type=script&lang=ts&"
export * from "./landingDenied.vue?vue&type=script&lang=ts&"
import style0 from "./landingDenied.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports